export default {
  APP_NAME: 'DotOrg',
  GO_BACK: 'Back',
  VIEW_PREVIOUS: 'View Previous',
  ALL: 'All',
  YES: 'Yes',
  NO: 'No',
  THANK_YOU: 'Thank you',
  APPLY: 'Apply',
  FILTER: 'Filter',
  SUBMIT: 'Submit',
  CONTACT_US: 'contact us',
  LAST_LABEL: 'Last',
  LAST_YEAR_LABEL: 'Last Year',
  THIS_YEAR_LABEL: 'This Year',
  THIS_YEAR_TOTAL_LABEL: 'This Year Total',
  LIFETIME_LABEL: 'Lifetime',
  LIFETIME_TOTAL_LABEL: 'Lifetime Total',
  REFERRED_BY_LABEL: 'Referred by:',
  CAPACITY_LABEL: 'Cap',
  PLANNED_LABEL: 'Planned',
  SHOW: 'Show',
  SHOW_SAMPLE: 'Show Sample',
  SHOW_X_MORE: 'Show {num} more',
  HIDE: 'Hide',
  HIDE_SAMPLE: 'Hide Sample',
  HIDE_MORE: 'Hide more',
  SHOW_MORE_OPTIONS_LABEL: 'Show More Options',
  SHOW_LESS_OPTIONS_LABEL: 'Show Fewer Options',
  PINNED: 'Pinned',
  GENERIC_ERROR: 'An error occurred.',
  GENERIC_ERROR_OF_SOME_KIND: 'There was an error of some kind',
  LAST_VISIT: 'Last visit: {when}',
  NA: 'N/A',
  FIRST: 'First',
  LAST: 'Last',
  MIDDLE: 'Middle',
  REQUIRED: 'Required',
  BAD: 'Bad',
  NOT_GOOD: 'Not good',
  OK: 'Ok',
  GOOD: 'Good',
  GREAT: 'Great',
  NONE: 'None',
  X_HOURS: '{hours} {hours, plural, =1 {Hour} other {Hours}}',
  LESS_THAN_1_HOUR: '<1 Hour',
  EXPAND: 'Expand',
  COLLAPSE: 'Collapse',
  COMPLETED: 'Completed',
  DAYS: 'days',
  DAY: 'day',
  MONTH: 'month',
  MONTHS: 'months',
  EXPORT: 'Export',
  VIEW_REPORT: 'View Report',
  LEFT: 'left',
  DAYS_LEFT: '{number} days left',
  ADDED_DATE: 'Added {date}',
  LAST_EDITED_DATE: 'Last Edited {date}',
  CHARACTERS: 'Characters',
  SEARCH: 'Search',
  NAME: 'Name',
  CATEGORIES: 'Categories',
  DONOR_CATEGORIES: 'Donor Categories',
  ASSIGNEE: 'Assignee',
  LAST_INTERACTION: 'Last Interaction',
  ACTIONS: 'Actions',
  SHOW_MORE: 'Show More',
  SHOW_LESS: 'Show Less',
  COPIED: 'Copied',
  PER_PAGE: 'Per Page',
  ADD_ITEM: 'Create "{item}"',
  CLOSE: 'Close',
  DATE_LABEL: 'Date',
  AMOUNT_LABEL: 'Amount',
  EMPLOYEE_LABEL: 'Employee',
  ACTION_LABEL: 'Action',
  ELEMENTS_LABEL: 'Elements',
  ENTITY_LABEL: 'Entity',
  IMPORT: 'Import',
  CONTRIBUTIONS: 'Contributions',
  INTERACTIONS: 'Interactions',
  CAMPAIGN: 'Campaign',
  CAMPAIGNS: 'Campaigns',
  ORGANIZATION_LABEL: 'Organization',
  DOWNLOAD_LABEL: 'Download',
  METHOD_LABEL: 'Method',
  BY: 'by',
  VIEW_ALL: 'View All',
  CATEGORY: 'Category',
  OPEN: 'Open',
  DISPLAY: 'Display',
  RELATIONSHIPS: 'Relationships',
  UPDATED: 'Updated',
  SEE_DETAILS: 'See Details',
  DONE: 'Done',
  LOADING: 'Loading...',
  STATUS: 'Status',
  ORG_NAME: 'Org Name',
  EMAIL: 'Email',
  SELECT_ALL: 'Select All',
  DATE_CREATED: 'Date Created',
  FILES: 'Files',
  UPLOAD_FILE: 'Upload File',
  TRUE: 'True',
  FALSE: 'False',
  ANY: 'Any',
  TOGGLE_MENU: 'Toggle Menu',
  ENTITY_DETAILS_ADDED_BY: 'Added {date} by {developerLink}',
  ENTITY_DETAILS_UPDATED_BY: 'Updated {date} by {developerLink}',
  TOTAL: 'Total',
  SHOW_ALL: 'Show all',
};
